import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
	setModoTela, initForm, getLista
} from './laudoImportacaoActions';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import Td from '../common/table/td';
import FormatUtils from '../common/formatUtils/FormatUtils';
import TBody from '../common/table/tBody';
import DateFormat from '../common/dateFormat/DateFormat';

class LaudoImportacaoForm extends Component {

	state = {
		paginacaoIndice: 0,
	}

	componentWillMount() {
		this.props.getLista(this.props.formularioValues.competencia, this.props.formularioValues.id_hospital);
	}

	render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		const formularioValues = { ...this.props.formularioValues };
console.log(formularioValues);

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardHeader>
						<div class='row' style={{ display: 'flex', justifyContent: 'space-between' }}>
							<Grid cols='12 6 3 3'>
								<label style={{ paddingTop: 12 }}>Competência: {FormatUtils.formatarCompetenciaTela(this.props.formularioValues.competencia)}</label>
							</Grid>
							<Grid cols='12 6 6 6'>
								<label style={{ paddingTop: 12 }}>Hospital: {this.props.formularioValues.nome_hospital}</label>
							</Grid>
						</div>
					</ContentCardHeader>
									
					<ContentCardBody>
						<Row>
							<Field
								name='id_importado'
								component={LabelAndInput}
								label='ID' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={200}
								readOnly={readOnly} />
						</Row>
						<Row>
							<Select
								name='id_radiologista'
								options={this.props.listaRadiologista}
								label='Radiologista *' placeholder='Informe'
								cols='12 6 3 3'
								readOnly={readOnly}
								value={formularioValues.id_radiologista}
								onChange={value => {
									const radiologista = this.props.listaRadiologista.filter(item => 
										item.id == value 
									)[0];
									
									this.props.initForm({
										...formularioValues,
										id_radiologista: radiologista ? radiologista.id : null,
										nome_radiologista: radiologista ? radiologista.valor : null
									})
								}} />
							
							<Select
								name='id_grupo_faturamento'
								options={this.props.listaGrupoFaturamentoRadiologista.filter(item => item.id_radiologista == formularioValues.id_radiologista).map(item => ({
									id: item.id_grupo_faturamento,
									valor: item .nome_grupo_faturamento
								}))}
								label='Grupo de Faturamento *' placeholder='Informe'
								cols='12 6 3 3'
								readOnly={readOnly}
								value={formularioValues.id_grupo_faturamento}
								onChange={value => {
									const grupoFaturamento = this.props.listaGrupoFaturamentoRadiologista.filter(item => 
										item.id_grupo_faturamento == value 
										&& item.id_radiologista == formularioValues.id_radiologista
									)[0];
									this.props.initForm({
										...formularioValues,
										id_grupo_faturamento: grupoFaturamento ? grupoFaturamento.id_grupo_faturamento : null,
										nome_grupo_faturamento: grupoFaturamento ? grupoFaturamento.nome_grupo_faturamento : null
									})
								}} />
							
							<Select
								name='id_contrato'
								options={Object.values(
									this.props.listaContratoItem
										.filter(item =>
											item.id_hospital == formularioValues.id_hospital &&
											(item.ids_grupo_faturamento || []).includes(formularioValues.id_grupo_faturamento)
										)
										.reduce((acc, item) => {

											const chave = `${item.id_contrato}_${item.data_inicio}`;

											if (!acc[chave]) {
												acc[chave] = {
													id: item.id_contrato,
													valor: DateFormat.formatarDataSqlParaTela(item.data_inicio),
												};
											}

											return acc;

										}, {})
								)}
								label='Contrato *' placeholder='Informe'
								cols='12 6 3 3'
								readOnly={readOnly}
								value={formularioValues.id_contrato}
								onChange={value => {
									const contrato = this.props.listaContratoItem.filter(item => 
										item.id_contrato == value 
										&& item.id_hospital == formularioValues.id_hospital
										&& (item.ids_grupo_faturamento || []).includes(formularioValues.id_grupo_faturamento)
									)[0];
									
									this.props.initForm({
										...formularioValues,
										id_contrato: contrato ? contrato.id_contrato : null,
										nome_contrato: contrato ? DateFormat.formatarDataSqlParaTela(contrato.data_inicio) : null,
									})
								}} />
							
							<Select
								name='id_hospital_convenio'
								options={this.props.listaHospitalConvenio.filter(item => item.id_hospital == formularioValues.id_hospital)}
								label='Convênio *' placeholder='Informe'
								cols='12 6 3 3'
								readOnly={readOnly}
								value={formularioValues.id_hospital_convenio}
								onChange={value => {
									const hospitalConvenio = this.props.listaHospitalConvenio.filter(item => 
										item.id == value 
									)[0];
									
									this.props.initForm({
										...formularioValues,
										id_hospital_convenio: hospitalConvenio ? hospitalConvenio.id : null,
										nome_hospital_convenio: hospitalConvenio ? hospitalConvenio.valor : null
									})
								}} />
						</Row>
						<Row>
							<Select
								name='id_exame'
								options={this.props.listaContratoItem.filter(item => 
									item.id_contrato == formularioValues.id_contrato 
									&& item.id_hospital_convenio == formularioValues.id_hospital_convenio
								).map(item => ({
									id: item.id_exame,
									valor: item.nome_exame
								}))}
								label='Exame *' placeholder='Informe'
								cols='12 4 4 3'
								readOnly={readOnly}
								value={formularioValues.id_exame}
								onChange={value => {
									const exame = this.props.listaContratoItem.filter(item => 
										item.id_exame == value 
										&& item.id_contrato == formularioValues.id_contrato 
										&& item.id_hospital_convenio == formularioValues.id_hospital_convenio
									)[0];
									
									this.props.initForm({
										...formularioValues,
										id_exame: exame ? exame.id_exame : null,
										nome_exame: exame ? exame.nome_exame : null,
										valor: exame ? FormatUtils.formatarValorTela(exame.valor, 0) : 0,
										percentual_imposto: exame ? FormatUtils.formatarValorTela(exame.percentual_imposto, 2) : 0
									})
								}} />

							<Field
								name='sigla_exame'
								component={LabelAndInput}
								label='Sigla do Exame' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={200}
								readOnly={readOnly} />
							
							<Field
								name='descricao_exame'
								component={LabelAndInput}
								label='Descrição do Exame' placeholder='Informe'
								cols='12 4 4 3'
								readOnly={readOnly} />

						</Row>
						<Row>
														
							<Field
								name='nome_paciente'
								component={LabelAndInput}
								label='Nome do Paciente' placeholder='Informe'
								cols='12 4 4 3'
								readOnly={readOnly} />
							
							<LabelAndInputDateTime
								label='Data do Exame'
								cols='12 1 1 1'
								readOnly={readOnly}
								value={formularioValues.datahora_exame}
								onChange={value => {
									this.props.initForm({
										...formularioValues,
										datahora_exame: value
									});
								}} />

							<Field
								name='laudo'
								component={LabelAndInput}
								label='Laudo' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={200}
								readOnly={readOnly} />
						</Row>
						<Row>
							<Field
								name='medico_solicitante'
								component={LabelAndInput}
								label='Médico Solicitante' placeholder='Informe'
								cols='12 6 6 3'
								readOnly={readOnly} />
								
							<Field
								name='digitador'
								component={LabelAndInput}
								label='Digitador' placeholder='Informe'
								cols='12 6 6 3'
								readOnly={readOnly} />
						</Row>
						<Row>
							<Field
								name='quantidade'
								component={LabelAndInputNumber}
								label='Quantidade *' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={200}
								casas={0}
								readOnly={readOnly} />

							<Field
								name='valor'
								component={LabelAndInputNumber}
								label='Valor *' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={200}
								casas={2}
								readOnly={readOnly} />
							
							<Field
								name='percentual_imposto'
								component={LabelAndInputNumber}
								label='Imposto (%) *' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={200}
								casas={2}
								readOnly={readOnly} />
						</Row>

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
									<Button
										text='Salvar'
										submit
										type={'success'}
										icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('listaImportada')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
	}

}

LaudoImportacaoForm = reduxForm({ form: 'laudoImportacaoForm', destroyOnUnmount: false })(LaudoImportacaoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('laudoImportacaoForm')(state),
	listaItens: state.laudoImportacao.listaItens,
	listaGrupoFaturamento: state.grupoFaturamento.listaSelect,
	listaRadiologista: state.radiologista.listaSelect,
	listaHospitalConvenio: state.hospitalConvenio.listaSelect,
	listaCompletaHospitalConvenio: state.hospitalConvenio.lista,
	listaGrupoFaturamentoRadiologista: state.laudoImportacao.listaGrupoFaturamentoRadiologista,
	listaContratoItem: state.laudoImportacao.listaContratoItem
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, getLista
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(LaudoImportacaoForm);
